"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Online = exports.InternalError = exports.NotFound = exports.Forbidden = exports.Fetching = exports.Offline = exports.ManifestGroup = void 0;
const state_flow_1 = require("@video/state-flow");
const player_options_1 = require("../../../../api/player-options");
const state_flow_2 = require("../state-flow");
//#endregion
//#region Group Declaration
exports.ManifestGroup = state_flow_2.PlayerStateFlow.registerGroup("manifest").bootstrap(() => {
    return (0, exports.Offline)({
        url: "",
        json: null,
        nextUpdate: 0,
        deadline: null,
        options: player_options_1.ManifestOptions.parse({}),
    });
});
//#endregion
//#region Signals Handlers
//
// function driverSupported({ manifest }: Groups, signal: Signals["driverSupported"]): StateResult<Props> {
//   const supportedDrivers = new Set(manifest.supportedDrivers);
//   supportedDrivers.add(signal.driver);
//   return { supportedDrivers: supportedDrivers as ReadonlySet<string> };
// }
function manifestReplaceUrl({ manifest }, signal) {
    try {
        new URL(signal.url); // validate URL
        return (0, exports.Fetching)({ ...manifest, nextUpdate: 0, json: null, url: signal.url });
    }
    catch (err) {
        return state_flow_1.Result.reject(`invalid URL: ${signal.url}`);
    }
}
function manifestUpdate(groups, signal) {
    var _a, _b, _c;
    const manifest = groups.manifest;
    if (signal.status === 401 || signal.status === 403) {
        if (manifest.options.refetch === 0) {
            return (0, exports.Forbidden)({ ...manifest, json: null });
        }
        else {
            return (0, exports.Fetching)({
                ...manifest,
                nextUpdate: manifest.options.polling.unauthorized,
                deadline: Date.now() + manifest.options.refetch,
                json: null,
            });
        }
    }
    if (signal.status === 404) {
        return (0, exports.Fetching)({ ...manifest, nextUpdate: manifest.options.polling.notfound, deadline: null, json: null });
    }
    if (signal.status >= 500 || signal.manifest == null) {
        return (0, exports.InternalError)({ ...manifest, json: null });
    }
    const oldFormats = new Set(Object.keys((_b = (_a = manifest.json) === null || _a === void 0 ? void 0 : _a.formats) !== null && _b !== void 0 ? _b : []));
    const newFormats = Object.keys(signal.manifest.formats);
    const newUrl = (_c = signal.manifest.self) !== null && _c !== void 0 ? _c : manifest.url;
    // if a list of formats has changed, we need to check if the current driver is still supported
    if (oldFormats.size !== newFormats.length || newFormats.some(f => !oldFormats.has(f)) || newUrl !== manifest.url) {
        return (0, exports.Online)({
            ...manifest,
            json: signal.manifest,
            url: newUrl, nextUpdate: manifest.options.polling.default,
            deadline: null,
        });
        //
        // const [drivers, cur] = getSupportedDrivers(groups);
        // const currentDriver = cur >= 0 ? drivers[cur] : null;
        // const newState = { json: signal.manifest };
        //
        // if (currentDriver == null || !providedFormats.has(currentDriver.driverFormat)) {
        //   // if the current driver is not supported anymore, we need to switch to the next one
        //   return driverSwitch(cloneState(groups.manifest, newState), {});
        // }
        //
        // // if the current driver is still supported, we can just update the state
        // return newState;
    }
    // otherwise, we can just update the manifest
    return state_flow_1.Result.ignore("no changes in manifest");
}
// function driverSwitch(groups: Groups, signal: Signals["driverSwitch"]): StateResult<Props> {
//   // calculate the list of drivers that are supported, requested by the user and provided by the manifest
//   const [drivers, cur] = getSupportedDrivers(groups);
//
//   if (drivers.length === 0) {
//     return NoDriversError(groups.manifest);
//   }
//
//   // cycle through the list of drivers
//   const currentDriver = getStateName(state);
//   const currentIndex = drivers.indexOf(currentDriver);
//   const nextIndex = currentIndex + 1 === drivers.length ? 0 : currentIndex + 1;
//   const nextDriver = drivers[nextIndex];
//
//   switch (nextDriver) {
//     case "native-hls":
//       return NativeHls(state);
//   }
//
//   // should never happen
//   // if it does, it means we have an issue in the code
//   return DriverNotFound(state);
// }
function optionsApply({ manifest }, signal) {
    return { options: signal.options.manifest };
}
//#endregion
//#region States Declarations
exports.Offline = exports.ManifestGroup.registerState("Offline", {
    optionsApply,
    manifestReplaceUrl,
    manifestUpdate,
});
exports.Fetching = exports.ManifestGroup.registerState("Fetching", {
    optionsApply,
    manifestReplaceUrl,
    manifestUpdate,
    manifestDeadline: (state) => (0, exports.Forbidden)(state.manifest),
});
exports.Forbidden = exports.ManifestGroup.registerState("Forbidden", {
    optionsApply,
    manifestReplaceUrl,
});
exports.NotFound = exports.ManifestGroup.registerState("NotFound", {
    optionsApply,
    manifestReplaceUrl,
    manifestUpdate,
});
exports.InternalError = exports.ManifestGroup.registerState("InternalError", {
    optionsApply,
    manifestReplaceUrl,
});
exports.Online = exports.ManifestGroup.registerState("Online", {
    optionsApply,
    manifestReplaceUrl,
    manifestUpdate,
});
//#endregion
//# sourceMappingURL=manifest.js.map